import axios from "axios";
import { configApi } from "./config";

const baseUrl = "https://recipe-vti-production.up.railway.app:443/api/v1/exchange";

export const createExchangeRecipeApi = async (data, token) => {
    const config = configApi(token);
    return await axios.post(baseUrl, data, config);
}